import React from "react";

import { GenericDetailsModal, Table } from "@components";
import { useAllCustomers } from "@api";

import { useGetCustomers } from "./useGetCustomers";
import { useManageCustomer } from "./useManageCustomer";

import { getCustomerDetails } from "./getCustomerDetailsSections";

import { STRING } from "@constants";

const T = STRING.CUSTOMER_DETAILS;

export function Customers() {
  const { data, loading, loadMore, hasMore } = useAllCustomers();
  const { columns } = useGetCustomers();
  const {
    handleRowClick,
    selectedCustomer,
    isDetailsModalOpen,
    handleCloseDetailsModal,
  } = useManageCustomer();
  const { sections } = getCustomerDetails(selectedCustomer);

  return (
    <div className="overflow-hidden">
      <GenericDetailsModal
        visible={isDetailsModalOpen}
        onHide={handleCloseDetailsModal}
        sections={sections}
        header={T.MODAL_HEADER}
        noDataText={T.NO_DATA}
      />
      <Table
        columns={columns}
        data={data}
        title="Customers"
        onRowClicked={handleRowClick}
        loading={loading}
        loadMore={hasMore ? loadMore : undefined}
      />
    </div>
  );
}
